import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { academylist, workerdelete, workerlist } from "../../../services/admin";
import Select from "react-select";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

export default function Deleteworkers() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState([]);
  const [filterProduct, setFilterProduct] = useState([]);

  const [sphoto, setSPhoto] = useState("");
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [acac, setAcac] = useState("");

  const [empid, setEmpID] = useState("");
  const [ddate, setDDate] = useState("");
  const [dreason, setDReason] = useState("");
  const [dremark, setDRemark] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/workers/workerdetail/${params.value}`)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a
              onClick={() => navigate(`/workers/profile/${params.value}`)}
              className="btn-sm btn-success"
            >
              <i className="fa fa-user"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Photo",
      width: 100,
      field: "worker_photo",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <img
              src={sphoto + params.value}
              onError={(ev) => errorphoto(ev)}
              style={{ height: "60px", width: "60px" }}
            />
          </div>
        );
      },
    },

    {
      headerName: "Name",
      field: "worker_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
     {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Emp ID",
      field: "employee_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "type_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date of Birth",
      field: "dob",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Blood Group",
      field: "blood_group",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone Number",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Qualification",
      field: "qualification",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Address 1",
      field: "address1",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Address 2",
      field: "address2",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "State",
      field: "state_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "District",
      field: "district",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "City",
      field: "city",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Pincode",
      field: "pincode",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);
   
if (localStorage.getItem("ADate") !== '') {
      setDDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    } else {
      setDDate(moment(new Date()).format("YYYY-MM-DD"));
    }
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

  
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                setAcac(arr[0]);
                listall(arr[0],path);
                listwork(arr[0]);
              }
            }
           
          }
        }
      });
    }else{
      listall("",path);
      listwork("");
    }

  }, [location.pathname]);
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e)
    } else {
      setAcaID("");
      listall("");
    }
  }

  function handleAcad(e) {
    if (e !== null) {
      setAcac(e);
      listwork(e)
    } else {
      setAcac("");
      listwork("")

    }
  }

  function listall(aid, atype) {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    if (atype == "deleteworkers") {
      temp.append("status", 0);
    } else {
      temp.append("status", 1);
    }

    workerlist(temp).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.details);
        setSPhoto(res.data.path);
      }
    })
  }

  function listwork(aid) {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("status", 1);

    workerlist(temp).then((res) => {
      if (res.status === true) {
        setFilter(res.data.details);
        setSPhoto(res.data.path);
      }
    })
  }
  const [show, setShow] = useState(false)
  function handleshow() {
    setShow(true)
    setEmpID("");
    setAcac("");
    setDDate(moment(new Date()).format("YYYY-MM-DD"));
    setDReason("");
    setDRemark("");
    setErrMsg("");
  }

  function handleclose() {
    setShow(false)
  }
  const [wphoto, setWorkerPhoto] = useState("");
  function handleEmpID(e) {
    let foundWorker = ""
    if (localStorage.getItem("Role") === "1" && e.target.value !== "") {
      if (acac !== "") {
        foundWorker = filter.find(worker =>
          worker.id == e.target.value && worker.academy_id === acac
        );
        setEmpID(e.target.value);
      } else {
        toast.error("Please Select Academy");
      }

    } else {
      foundWorker = filter.find(worker =>
        worker.id == e.target.value
      );
      setEmpID(e.target.value);
    }

    if (foundWorker) {
      setWorkerPhoto(sphoto + foundWorker.worker_photo);
    } else {
      setWorkerPhoto('');
    }

  }


  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/teacher.jpg");
    ev.target.onerror = null;
  }

  const [errmsg, setErrMsg] = useState("");

  function deletesubmit(e) {
    e.preventDefault();
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acac === "") {
        setErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (empid !== "") {
        if (ddate !== "") {
          if (dreason !== "") {
            const temp = new FormData();
            temp.append("id", empid);
            temp.append("delete_date", ddate);
            temp.append("delete_reason", dreason);
            temp.append("delete_remark", dremark);
            if (localStorage.getItem("Role") === "1" && acac !== "") {
              temp.append("academy_id", acac.value);
            }
            workerdelete(temp).then((res) => {
              if (res.status === true) {
                handleclose();
                toast.success(res.message);
                navigate("/workers/deleteworkers");
              }
            })

          } else {
            setErrMsg("Please Enter Reason");
          }
        } else {
          setErrMsg("Please Select Delete Date");
        }
      } else {
        setErrMsg("Please Select Employee ID");
      }
    }


  }
  return (
    <div>
      <div className="page-header">
        {urllink === "deleteworkers" && (
          <h2 className="main-content-title tx-24 mg-b-5">Delete Worker</h2>
        )}
        {urllink === "workerlist" && (
          <h2 className="main-content-title tx-24 mg-b-5">All Worker</h2>
        )}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Worker</a>
          </li>
          {urllink === "deleteworkers" && (
            <li className="breadcrumb-item active" aria-current="page">
              Delete Worker
            </li>
          )}
          {urllink === "workerlist" && (
            <li className="breadcrumb-item active" aria-current="page">
              All Worker
            </li>
          )}

        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">


          <div className="card custom-card mg-b-20">
            <div className="card-body">

              <div className="row">
              <div className="col-xl-6 col-sm-6">

                {localStorage.getItem("Role") === "1" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={alist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />

                    </div>
                )}
                  </div>

                {urllink === "deleteworkers" &&
                  <div className="col-xl-6 col-sm-6">
                    <div className="text-right mt-2">
                      <a className="btn btn-success" onClick={handleshow} >Add Delete Worker</a>
                    </div>
                  </div>
                }

              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>

          <Modal show={show} size="lg">
            <Modal.Header>
              <Modal.Title>Add Delete Worker</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-xl-3 col-lg-4">
                  <label className="form-label">Photo</label>
                  <div className="avatar-upload">
                    <div className="avatar-preview">
                      <img
                        src={wphoto}
                        alt="Worker"
                        onError={(e) => errorphoto(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-9 col-lg-8">
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acac}
                            options={alist}
                            onChange={handleAcad}
                            isSearchable={true}
                            isClearable
                            hidden
                          />

                        </div>
                      </div>
                    )}
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Employee ID <span className="text-danger"> *</span>
                        </label>
                        <select className="default-select form-control wide" value={empid} onChange={(e) => handleEmpID(e)}>
                          <option value="" disabled>
                            Select Employee ID
                          </option>
                          {filter.map((data) => {
                            return (
                              <option value={data.id} key={data.id}>
                                {data.employee_id}
                              </option>
                            );
                          })

                          }
                        </select>
                      </div>
                    </div>

                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Delete Date{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group">
                          <input className="form-control" type="date" value={ddate} onChange={(e) => setDDate(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Reason <span className="text-danger"> *</span>
                        </label>
                        <textarea
                          rows="2"
                          className="form-control"
                          placeholder="Enter Reason"
                          value={dreason}
                          onChange={(e) => setDReason(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Remark</label>
                        <textarea
                          rows="2"
                          className="form-control"
                          placeholder="Enter Remark"
                          value={dremark}
                          onChange={(e) => setDRemark(e.target.value)}
                        />
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              {errmsg !== "" && (
                <span className="text-danger">
                  {errmsg}
                </span>
              )}
            </Modal.Body>
            <Modal.Footer>
              <a className="btn btn-secondary" onClick={handleclose}>
                Close
              </a>
              <a className="btn btn-success" onClick={deletesubmit}>
                Submit
              </a>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
}
